'use client';

import { type ReactNode } from 'react';

import { Divider } from '@libs/common-next';

import { BaseDrawer } from '@/shared/ui';

import { useFulfilmentDrawerStore } from './model';
import { AutoshipDetails, Options, ProductInfo } from './ui';

import './styles.scss';

type FulfilmentSelectionDrawerProps = {
    addToCartSlot: ReactNode;
    selectFrequencySlot: ReactNode;
};

export const FulfilmentSelectionDrawer = ({ selectFrequencySlot, addToCartSlot }: FulfilmentSelectionDrawerProps) => {
    const { isOpen, close } = useFulfilmentDrawerStore();

    return (
        <BaseDrawer
            isOpen={isOpen}
            onCloseAction={close}
            title="Set up Autoship"
            testId="fulfilment-selection-drawer"
            className="fulfilment-selection-drawer"
        >
            <div className="fulfilment-selection-drawer__inner">
                <div className="fulfilment-selection-drawer__top">
                    <ProductInfo />
                    {selectFrequencySlot}
                </div>
                <Divider />
                <div className="fulfilment-selection-drawer__body">
                    <AutoshipDetails />
                    <Options />
                </div>
                <div className="fulfilment-selection-drawer__footer">{addToCartSlot}</div>
            </div>
        </BaseDrawer>
    );
};
